import { isUndefined } from '../../../utils/isDefined';

const getDisabledFields = ({ user, fromuserProfile, isBulkRequest }) => {
  if (isBulkRequest) {
    return {
      sendForMobile: false,
      sendForSoftphone: false,
      sendForWebSoftphone: false
    };
  }

  const isSoftphoneAvailable = fromuserProfile
    ? !isUndefined(findValue(user, 'SOFT'))
    : Boolean(user?.softphoneEnabled);

  return {
    sendForMobile: isUndefined(findValue(user, 'MOBILE')),
    sendForSoftphone: !isSoftphoneAvailable,
    sendForWebSoftphone: !user?.mitelData?.web_softphone
  };
};

export default getDisabledFields;

const findValue = (user, value) => {
  if (isUndefined(user)) {
    return undefined;
  }

  const answerPlaces = user?.mitelData?.answer_places || [];

  if (value === 'MOBILE') {
    return answerPlaces.find(
      place => place.type === value && place.client === 'STANDARD'
    );
  }

  return answerPlaces.find(place => place.type === value);
};
